<template>
  <div class="opc-payment-method__wrap">
    <terms v-if="showSepaTerms" />
    <component
      v-for="item in componentList"
      :is="item.comp"
      :ref="item.payMethodKey"
      v-show="paymentMethod === item.payMethodKey"
      :is-form-visible="paymentMethod === item.payMethodKey"
      :paymethod="item.payMethodKey"
      :key="item.payMethodKey"
      :indiaMandateAmount="indiaMandateAmount"
      :save-disabled="saveDisabled"
      @authorize="(e) => $emit('authorize', e)"
      @loading-start="onLoadingStart"
      @loading-close="onLoadingClose"
      @submit-success="onSubmitSuccess"
      @submit-error="onSubmitError"
      @submit-start="onSubmitStart"
    >
      <zm-alert
        v-if="alertVisible"
        show-icon
        type="error"
        :closable="false"
        slot="payment-method-error"
        :title="__$t('billing.payment.update_pay_method_tips')"
        class="opc-payment-method__error"
      />
    </component>
    <terms
      v-if="showInrTerms"
      :indiaMandateAmountFormatted="indiaMandateAmountFormatted"
      :enableInrRecurringChargesTable="enableInrRecurringChargesTable"
    />
  </div>
</template>

<script type="text/jsx">
import { mapGetters } from "vuex";
import Credit from "./credit";
import PayPal from "./PayPal";
import ApplePay from "./ApplePay";
import GooglePay from "./GooglePay.vue";
import Terms from "../terms";
import ACH from "./AchBankTransfer.vue";
import SEPA from "./SepaBankTransfer.vue";
import APM from "./APM.vue";
import { payMethodMap } from "../../common/constant";
import { translateMixins } from "../../plugins/i18n";
import { isInrCurrency } from "../../utils/currency";
import { APP_NAMESPACE } from "../../store";
import { apmPaymentType } from "../../utils";

export default {
  components: { Credit, PayPal, ApplePay, GooglePay, ACH, SEPA, Terms, APM },
  props: {
    paymentMethod: String,
    alertVisible: Boolean,
    saveDisabled: Boolean,
    indiaMandateAmount: {
      type: String,
      validator: (val) => parseInt(val).toString() === val
    },
    indiaMandateAmountFormatted: String,
    enableInrRecurringChargesTable: Boolean
  },
  mixins: [translateMixins],
  computed: {
    ...mapGetters(APP_NAMESPACE, ['isSepaEligible', 'apmInfo']),
    apmPaymentMethodName() {
      return this.apmInfo.apmPaymentMethodName
    },
    apmImageFileName() {
      return this.apmInfo.tileImageFileName
    },
    showSepaTerms() {
      return this.isSepaEligible && this.paymentMethod === payMethodMap.sepa
    },
    showInrTerms() {
      return isInrCurrency()
    },
    componentList() {
      return [{
        comp: 'Credit',
        payMethodKey: payMethodMap.credit,
      }, {
        comp: 'PayPal',
        payMethodKey: payMethodMap.paypal,
      }, {
        comp: 'GooglePay',
        payMethodKey: payMethodMap.google,
      }, {
        comp: 'ApplePay',
        payMethodKey: payMethodMap.apple,
      }, {
        comp: 'Credit',
        payMethodKey: payMethodMap.creditByIndia
      },{
        comp: 'ACH',
        payMethodKey: payMethodMap.ach,
      },{
        comp: 'SEPA',
        payMethodKey: payMethodMap.sepa,
      }
      ,{
        comp: 'APM',
        payMethodKey: apmPaymentType(this.apmPaymentMethodName, this.apmImageFileName)
      }
    ]},
  },
  methods: {
    onLoadingClose(msg) {
      this.$emit('loading-close', msg)
    },
    onLoadingStart(msg) {
      this.$emit('loading-start', msg)
    },
    onSubmitStart(msg) {
      this.$emit('submit-start', msg)
    },
    onSubmitError(err) {
      this.$emit('submit-error', err)
    },
    onSubmitSuccess(res) {
      this.$emit('submit-success', res)
    },
    $submit(data) {
      let currentForm = this.$refs[this.paymentMethod]
      if(!currentForm) {
        throw new Error('invalid paymethod')
      }
      currentForm = currentForm[0] || currentForm;
      return currentForm.$submit(data)
    }
  },
}
</script>

<style lang="scss">
.opc-payment-method {
  &__error {
    display: flex;
    align-items: center;
    background: #f3c2d0;
    color: #80384d;
    padding: 8px 12px;
    margin-top: 32px;
  }

  &__hidden {
    display: none;
  }
}
</style>
